import React, { FC } from 'react';

interface UploadQuizzInput {
  icon: string;
  id: string;
  fileName?: string;
  file?: File;
  onchange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
}

const UploadQuizzInput: FC<UploadQuizzInput> = ({
  icon,
  id,
  fileName,
  onchange,
  accept,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      }}
    >
      <label
        htmlFor={id}
        className={`flex flex-col  justify-start items-center px-[1em] py-8 rounded-lg cursor-pointer`}
      >
        <img src={icon} alt="icon" className="form-input-w-img__icon" />
        <div className="text-white relative border-[none]">
          <input
            className="opacity-0 absolute z-[2] w-full h-full cursor-pointer"
            type="file"
            id={id}
            onChange={onchange}
            accept={accept}
          />
          <span
            className={`relative block text-center z-[1] pointer-events-none text-[inherit] font-light p-4`}
          >
            {fileName}
          </span>
        </div>
      </label>
    </div>
  );
};

export default UploadQuizzInput;
